import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postMotorFourStart,
  postMotorFourSuccess,
  postMotorFourFailure,
} from "../reducers/postMotorFourReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const postMotorFour = createAsyncThunk(
  "postMotorFour",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postMotorFourStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Motor/Savesurveyorvisit`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postMotorFourSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postMotorFourFailure(error.response.data.Message));

      throw error;
    }
  }
);
